export enum PadAttributeIcon {
  lightning = 'lightning',
  route = 'route',
  doc = 'doc',
  pin = 'pin',
}

export const isPadAttributeIcon = (icon: unknown): icon is PadAttributeIcon =>
  typeof icon === 'string' && Object.values<string>(PadAttributeIcon).includes(icon);
